import { useOptionalTheme } from './chunk-NH2JFPA3.js';
import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import Editor from '@monaco-editor/react';
import { jsx } from 'react/jsx-runtime';

function JsonEditor({
  value,
  onChange,
  onParse,
  readOnly = false,
  height = 320,
  className,
  language = "json"
}) {
  const theme = useOptionalTheme();
  const resolvedMode = theme?.resolvedMode ?? (typeof document !== "undefined" && document.documentElement.classList.contains("dark") ? "dark" : "light");
  const handleChange = React.useCallback(
    (next = "") => {
      onChange(next);
      if (!onParse) return;
      try {
        const parsed = next.trim() === "" ? null : JSON.parse(next);
        onParse(parsed, null);
      } catch (err) {
        onParse(null, err);
      }
    },
    [onChange, onParse]
  );
  const handleMount = React.useCallback((editor) => {
    editor.updateOptions({ minimap: { enabled: false }, fontSize: 13 });
  }, []);
  return /* @__PURE__ */ jsx("div", { className: cn("overflow-hidden rounded-md border", className), children: /* @__PURE__ */ jsx(
    Editor,
    {
      height,
      defaultLanguage: language,
      value,
      theme: resolvedMode === "dark" ? "vs-dark" : "vs",
      onChange: handleChange,
      onMount: handleMount,
      options: {
        readOnly,
        minimap: { enabled: false },
        scrollBeyondLastLine: false,
        tabSize: 2,
        formatOnPaste: true,
        formatOnType: false,
        fontFamily: "var(--font-mono)",
        wordWrap: "on"
      }
    }
  ) });
}

export { JsonEditor };
//# sourceMappingURL=chunk-23FOSIQH.js.map
//# sourceMappingURL=chunk-23FOSIQH.js.map